import { defineStore } from "pinia";
import { computed, ref } from "vue";

import { type Nullable } from "shared/types";
import type { MentionOrCustomerArticle } from "shared/types/mentions";

export const useMobileStore = defineStore("mobile", () => {
  const containerOffset = ref<string>("");
  const keyboardHeight = ref<number>(0);
  const keyboardOpen = ref<boolean>(false);
  const orientationAngle = ref<Nullable<number>>(0);
  const selectedMention = ref<Nullable<MentionOrCustomerArticle>>(null);

  const getOrientation = computed(() => {
    if (
      orientationAngle.value !== null &&
      Math.abs(orientationAngle.value) === 90
    )
      return "landscape";

    return "portrait";
  });

  const getKeyboardOpenStyle = computed(() =>
    keyboardOpen.value ? { marginBottom: `${keyboardHeight.value}px` } : {}
  );

  function updateKeyboardOpen(open: boolean) {
    keyboardOpen.value = open;
  }

  function setKeyboardHeight(height: number) {
    keyboardHeight.value = height;
  }

  function setSelectedMention(mention: Nullable<MentionOrCustomerArticle>) {
    selectedMention.value = mention;
  }

  function setContainerOffset(offset: string) {
    containerOffset.value = offset;
  }

  function setOrientationAngle(angle: number) {
    orientationAngle.value = angle;
  }

  return {
    containerOffset,
    getKeyboardOpenStyle,
    getOrientation,
    keyboardHeight,
    keyboardOpen,
    orientationAngle,

    selectedMention,

    setContainerOffset,
    setKeyboardHeight,
    setOrientationAngle,
    setSelectedMention,
    updateKeyboardOpen,
  };
});

export default useMobileStore;
